import { render } from "./SegmentRefineProposalModal.vue?vue&type=template&id=c85578b4"
import script from "./SegmentRefineProposalModal.vue?vue&type=script&lang=js"
export * from "./SegmentRefineProposalModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/pathways/SegmentRefineProposalModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c85578b4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c85578b4', __exports__)) {
    api.reload('c85578b4', __exports__)
  }
  
  module.hot.accept("./SegmentRefineProposalModal.vue?vue&type=template&id=c85578b4", () => {
    api.rerender('c85578b4', render)
  })

}


export default __exports__